import { render, staticRenderFns } from "./taskDashboardBox.vue?vue&type=template&id=24501f2e&"
import script from "./taskDashboardBox.vue?vue&type=script&lang=js&"
export * from "./taskDashboardBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports